
import commaNumber from 'comma-number'
import { itemDisplayAmountAndSymbol } from '@/helpers/currencyDisplay'

export default {
  data() {
    return {
      sortingType: null
    }
  },
  computed: {
    results () {
      const results = this.$store.state.searchResults
      if (!results.length) return []
      return results
    },
    getSortedResults () {
      return this.$store.state.sortResults
    },
    bestPrices () {
      const state = this.$store.state
      const { recommended, cheapest, fastest } = this.getSortedResults || {}
      const recommendedList = this.toList(recommended)
      const cheapestList = this.toList(cheapest)
      const fastestList = this.toList(fastest)
      const results = this.results
      const base = results[0]
      const pick = (row) => {
        const item = row != null ? row : base
        if (!item) return { amount: 0, symbol: '' }
        return itemDisplayAmountAndSymbol(item, state)
      }
      return {
        recommended: pick(recommendedList[0]),
        fastest: pick(fastestList[0]),
        cheapest: pick(cheapestList[0])
      }
    }
  },
  mounted() {
    this.sortingType = 'recommended'
    this.$store.commit('setSortingType', this.sortingType)
  },
  methods: {
    toList (value) {
      return Array.isArray(value) ? value : []
    },
    submit(type) {
      this.sortingType = type
      this.$store.commit('setSortingType', type)
    },
    formatMoney (n) {
      return commaNumber(Math.round(n))
    },
    avgTime() {
      const { recommended, cheapest, fastest } = this.getSortedResults || {}
      const recommendedList = this.toList(recommended)
      const cheapestList = this.toList(cheapest)
      const fastestList = this.toList(fastest)
      return {
        recommended: this.calculateAvgTime(recommendedList) ?? '',
        fastest: this.calculateAvgTime(fastestList) ?? '',
        cheapest: this.calculateAvgTime(cheapestList) ?? ''
      }
    },
    calculateAvgTime(sortedResults) {
      if (!sortedResults || !sortedResults.length) {
        return
      }
      const durations = sortedResults.map(object => object.duration)
      const avgTime = durations.reduce((sum, duration) => sum + duration, 0) / durations.length / 2

      return Math.floor(avgTime / 60) + 'h ' + Math.floor(avgTime % 60)
    }
  }
}
